import {createTheme} from "@mui/material";

export default createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#0078AB", // lake
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: "#FFAD02", // yorange
      // dark: will be calculated from palette.secondary.main,
      // contrastText: "#ffcc00",
    },
    success: {
      main: "#6BA342",
    },
    error: {
      main: "#D62E4F",
    },
    warning: {
      main: "#DDAD49",
      contrastText: "#FFFFFF",
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    // contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    // tonalOffset: 0.2,
  },
});
